import React from "react"
import Lang from "@components/Lang/Lang";
import {Input, Select, Table, Spin, Button,} from "antd";
import ExportBtn from '@/components/ExportBtn/index';
import Cookie from "@utils/cookie";
import {isEmpty} from "@utils/utils";
import dayjs from "dayjs";
import {postFenxiaoList} from '@/api/dataStatistics';
import './index.less';
import ExportData from "@pages/DataStatistics/Distributor/component/ExportData";
import CommonBreadcrumb from "@components/CommonBreadcrumb"

const { Search } = Input
const { Option } = Select
const { Column, ColumnGroup } = Table
class Sale extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showExportModal: false,
            loading: true,
            filter: {
                buyerCode: null,
                poCode: null,
            },
            list: [],
            pagination: {
                pageSize: 50,
                total: 0,
                pageNum: 1
            },
            fxUserId:'',
        }
    }

    /** input 中的搜索*/
    onSearch(value) {
        // console.log(233, this);
        this.setState({
            filter: {
                ...this.state.filter,
                buyerCode: (value&&value.trim()) || null,
            },
            pagination: {
                ...this.state.pagination,
                pageNum: 1,
            },
        }, () => {
            this.getList()
        })

    }

    /*input onChange*/
    inputOnChange(event) {
        // console.log('input OnChange', event);
        this.setState({
            filter: {
                ...this.state.filter,
                poCode: (event.target.value&&event.target.value.trim()) || null,
            }
        })
    }

    getList() {
        this.setState({
            loading: true
        }, () => {
            postFenxiaoList({
                ...this.state.filter,
                pagingQuery: {
                    pageIndex: this.state.pagination.pageNum,
                    pageSize: this.state.pagination.pageSize,
                },
            }).then(res => {
                // console.log(res.data);
                res.data.models.forEach((item, index) => {
                    item.key = index.toString()
                })
                this.setState({
                    list: res.data.models || [],
                    pagination: res.data.paging || {},
                    loading: false,
                })
            })
        })
    }

    onChange(pagination, filters, sorter, extra){
        this.setState({
            pagination: {
                ...this.state.pagination,
                pageNum: pagination.current,
                pageSize: pagination.pageSize,
            },
        }, () => {this.getList()})
    }
    init(){
        const {fxUserId} = Cookie.getJSON("fmg.extra") || {};
        this.setState({
            fxUserId:fxUserId||""
        })
    }
    componentDidMount() {
        this.init();
        this.getList();

    }

    render() {
        const { fxUserId } = this.state;
        return (
            <div className="dataStatistics-distributor customer-screen">
                <CommonBreadcrumb
                    list={[{ name: Lang({id: 'FenXiaoShangTiCheng', default: '分销商提成'}) }]}
                ></CommonBreadcrumb>
                <p className='top-title mb_16 fw_700 font-18'>{Lang({id: 'FenXiaoShangTiCheng', default: '分销商提成'})}</p>

                <div data-flex="cross:center main:justify" className="mb_16">
                    <div className="filter-box">
                        <Input placeholder={Lang({id: 'QingShuRuDingDanHao', default: '请输入订单号'})}
                               onChange={this.inputOnChange.bind(this)}
                               className="mr_12"
                               style={{ width: 204 }} />
                        <Search placeholder={Lang({id: 'QingShuRuCaiGouShangBianMaHuoMingCheng', default: '请输入采购商编码或名称'})}
                                onSearch={(value) => this.onSearch(value)}
                                className=''
                                style={{ width: 288 }} />
                    </div>
                    {/* 分销商 账号不能 导出 */}
                    {isEmpty(fxUserId)&&<ExportBtn authName="DataStatistics-Distributor-Export-Button" onClick={() => {this.setState({showExportModal: true})}}></ExportBtn>}
                </div>

                <Spin spinning={this.state.loading}>
                    {/*表格*/}
                    <Table pagination={{defaultPageSize: this.state.pagination.pageSize, showQuickJumper: true, total: this.state.pagination.total, current: this.state.pagination.pageNum || 1, showSizeChanger: true, showTotal: (total) => `Total ${total} items`,}}
                           onChange={this.onChange.bind(this)}
                           dataSource={this.state.list}>
                        <Column title={Lang({id: 'FenXiaoShangXingMing', default: '分销商姓名'})} dataIndex="fucName" key="fucName" />

                        <Column title={Lang({id: 'CaiGouShang', default: '客户编码'})} dataIndex="buyerCode" key="buyerCode"/>

                        <Column title={Lang({id: 'PODanHao', default: 'PO单号'})} dataIndex="poCode" key="poCode"
                                render={(text, record, index) => (
                                    <a  href={`/order/sale/detail?id=${record.poId}`}>{record.poCode}</a>
                                )}/>

                        <Column title={Lang({id: 'XiaDanShiJian', default: '下单时间'})}
                                dataIndex="createTime"
                                key="createTime"
                                render={(text, record, index) => (
                                    <p>{record.createTime?dayjs(record.createTime).format("YYYY-MM-DD"):'-'}</p>
                                )}/>

                        <Column title={Lang({id: 'ZhiFuWeiKuanShiJian', default: '支付尾款时间'})}
                                dataIndex="happenTime"
                                key="happenTime"
                                render={(text, record, index) => (
                                    <p>{record.happenTime?dayjs(record.happenTime).format("YYYY-MM-DD"):'-'}</p>
                                )}/>

                        <Column title={Lang({id: 'TiChengBiLi', default: '提成比例'})} dataIndex="commissionRate" key="commissionRate" />

                        <Column title={Lang({id: 'EXWZongJia', default: 'EXW总价'})}
                                dataIndex="exw"
                                key="exw"
                                render={(text, record, index) =>(
                                    <p>{record.currencySymbol} {parseFloat(record.exw||0).toFixed(2)}</p>
                                )} />

                        <Column title={Lang({id: 'TiChengJinE', default: '提成金额'})}
                                dataIndex="commissionMoney"
                                key="commissionMoney"
                                render={(text, record, index) => (
                                    <p>{record.currencySymbol} {parseFloat(record.commissionMoney || 0).toFixed(2)}</p>
                                )}/>
                    </Table>
                    {/* 分销商账号不能导出 */}
                    <ExportData isModalVisible={this.state.showExportModal} showSwich={(isShow) => {this.setState({showExportModal: isShow})}}></ExportData>
                </Spin>

            </div>
        )
    }
}

export default Sale
